import { addBearing, formatDate, formatTime } from "./baseParser";

/**
 *  $RMC & GGA Rows have been extracted - indexes of arrays correspond to field numbers specified in following link
 *  https://gpsd.gitlab.io/gpsd/NMEA.html#_rmc_recommended_minimum_navigation_information
 *
 * returns a time sorted unique array of GPS records
 */
export function parseRawData(fileData) {
  const row = fileData.split("\n");
  const splitRows = row.map((x) => x.split(","));
  const dataRMC = splitRows.filter((x) => x[0].endsWith("RMC"));
  const dataGGA = splitRows.filter((x) => x[0].endsWith("GGA"));

  const rmcArray = dataRMC.map((rmc) => {
    const dateTime = new Date(convertGpsDate(rmc[9]) + convertGpsTime(rmc[1]));
    const sortingKey = new Date("1970-01-01" + convertGpsTime(rmc[1]));
    return {
      sortingKey,
      dateTime,
      latitude: coordinateConvert(rmc[3], true),
      longitude: coordinateConvert(rmc[5], false),
      date: convertGpsDate(rmc[9]),
      speed: convertSpeed(rmc[7]),
      time: convertGpsTime(rmc[1]),
      dateDisplay: formatDate(dateTime),
      timeDisplay: formatTime(dateTime),
      dateSet: true,
    };
  });
  const ggaArray = dataGGA.map((gga) => {
    const dateString =
      rmcArray.length > 0
        ? rmcArray[0].dateTime.toISOString().substring(0, 10)
        : "1970-01-01";
    const dateTime = new Date(dateString + convertGpsTime(gga[1]));
    const sortingKey = new Date("1970-01-01" + convertGpsTime(gga[1]));
    return {
      sortingKey,
      dateTime,
      latitude: coordinateConvert(gga[2], true),
      longitude: coordinateConvert(gga[4], false),
      speed: "Unknown",
      time: convertGpsTime(gga[1]),
      dateDisplay: formatDate(dateTime),
      timeDisplay: formatTime(dateTime),
      dateSet: rmcArray.length > 0,
    };
  });

  const mergedData = [...rmcArray, ...ggaArray];
  const uniqueRows = Array.from(new Set(mergedData.map((a) => a.time))).map(
    (time) => {
      return mergedData.find((a) => a.time === time);
    }
  );
  const sortedRows = uniqueRows.sort((a, b) => a.sortingKey - b.sortingKey);

  return addBearing(sortedRows);
}

//converting latitude/longitude from the given geometry string
function coordinateConvert(geom, latitude) {
  const wholepart = latitude ? geom.slice(0, 2) : geom.slice(0, 3);
  const fractional = latitude
    ? geom.slice(2, 4) + geom.slice(4, 10)
    : geom.slice(3, 5) + geom.slice(5, 11);

  const combinedResult = parseInt(wholepart) + parseFloat(fractional) / 60;
  const result = latitude ? "-" + combinedResult : combinedResult;

  return parseFloat(result).toFixed(6);
}

//converts speed into a whole number and converts from knots to km/h
function convertSpeed(speed) {
  return `${(speed = parseInt(speed * 1.852))} km/h`;
}

//creates a string that can be used to create a date object
function convertGpsTime(time) {
  const convertHr = time.slice(0, 2) + ":" + time.slice(2);
  const convertMin = convertHr.slice(0, 5) + ":" + convertHr.slice(5);
  const finalTime = "T" + convertMin + "Z";

  return finalTime;
}

//creates a date string that can be used to create a date object - appends year with '20' as data row only gives us last two digits
function convertGpsDate(date) {
  const day = date.slice(0, 2);
  const month = date.slice(2, 4);
  const year = date.slice(4, 6);
  const finalDate = "20" + year + "-" + month + "-" + day;

  return finalDate;
}

export const exportedForTesting = {
  convertGpsTime,
  convertGpsDate,
  coordinateConvert,
};
